import environment from './environment'

export const Logger = {
  log: (message?: any, ...optionalParams: any[]) => {
    if (environment.ENV !== 'production')
      console.log(message, ...optionalParams)
  },
}
